import { render, staticRenderFns } from "./Detail_customer_point.vue?vue&type=template&id=0eeb58c2&scoped=true&"
import script from "./Detail_customer_point.vue?vue&type=script&lang=js&"
export * from "./Detail_customer_point.vue?vue&type=script&lang=js&"
import style0 from "./Detail_customer_point.vue?vue&type=style&index=0&id=0eeb58c2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0eeb58c2",
  null
  
)

export default component.exports